
import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { RecommendationCardProps } from './types';

const RecommendationCard: React.FC<RecommendationCardProps> = ({ node, index }) => {
  return (
    <div className="flex items-center justify-between p-3 rounded-lg border hover:bg-muted/50 transition-colors">
      <div className="flex-1">
        <h4 className="font-medium text-sm mb-1">{node.title}</h4>
        <div className="flex items-center gap-2">
          <Badge variant="outline" className="text-xs">
            {node.node_type}
          </Badge>
          {node.disciplines && (
            <Badge variant="secondary" className="text-xs">
              {node.disciplines.name}
            </Badge>
          )}
        </div>
      </div>
      <Link to={`/node/${node.id}`}>
        <Button size="sm" variant="outline">
          <ArrowRight className="h-4 w-4" />
        </Button>
      </Link>
    </div>
  );
};

export default RecommendationCard;
